import {ApplyGameFilterResult} from "../../evaluators/game-filter-evaluator.interface";
import {GameInfo} from "../../../games/game-info";
import {GameFilterDefinitionBase} from "../game-filter-definition-base";

export class MediumVolatilityFilterDefinition extends GameFilterDefinitionBase {
    get id(): string {
        return 'medium-volatility';
    }

    get text(): string {
        return this.services.translation.translate('MEDIUM_VOLATILITY');
    }

    applyFilter(gameInfo: GameInfo): ApplyGameFilterResult {
        if (gameInfo.hasMediumVolatility) {
            return ApplyGameFilterResult.IncludeGame;
        }
        
        return ApplyGameFilterResult.ExcludeGame;
    }
}